import React from 'react';
import { ViewDropdown } from './ViewDropdown';
import { ViewValues } from '@g17eco/types/surveyOverview';

type Props = {
  view: ViewValues;
  onChangeView: (view: ViewValues) => void;
  actionBtns: React.JSX.Element;
  children: React.JSX.Element;
};

export const ViewTemplate = ({ view, onChangeView, actionBtns, children }: Props) => {
  return (
    <>
      <div className='d-flex align-items-center mt-3'>
        <span className='me-2'>View:</span>
        <ViewDropdown view={view} onChangeView={onChangeView} />
        {actionBtns}
      </div>
      <div className='mt-3'>{children}</div>
    </>
  );
};
